import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const OrderConfirmationSkeleton = () => {
  return (
    <>
      <section className="checkout-orderCompleted checkoutOrdercompleted">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="orderSummited text-center">
                <Skeleton circle height={60} width={60} />
                <div className="order-summited-info">
                  <Skeleton height={28} width={300} style={{ marginTop: 16 }} />
                  <Skeleton height={16} width={200} style={{ marginTop: 8 }} />
                  <Skeleton height={16} width={280} style={{ marginTop: 4 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="checkoutOrder-section checkoutOrderSection">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-md-8 offset-md-2 checkout-left">
              <div className="row">
                {/* Order Details Skeleton */}
                <div className="col-lg-12">
                  <div className="summited-order-details">
                    <Skeleton height={24} width={150} style={{ marginBottom: 16 }} />
                    <div className="cc-summited-order orderComplete-submit">
                      <div className="row">
                        {Array.from({ length: 6 }).map((_, index) => (
                          <div className="col-sm-6 col-md-12 col-lg-6" key={index}>
                            <div className="placed-order-details1">
                              <div className="cc-placed-order">
                                <div className="placed-order-info" style={{ marginBottom: 8 }}>
                                  <Skeleton height={16} width="80%" style={{ marginBottom: 8, padding: 0 }} />
                                  <Skeleton height={12} width="70%" style={{ marginBottom: 8, padding: 0 }} />
                                  {index >= 4 && (
                                    <>
                                      <Skeleton height={12} width="60%" style={{ marginTop: 4, padding: 0 }} />
                                      <Skeleton height={12} width="70%" style={{ marginTop: 4, padding: 0 }} />
                                      <Skeleton height={12} width="65%" style={{ marginTop: 4, padding: 0 }} />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Order Summary Skeleton */}
                <div className="col-lg-12">
                  <div className="orderCompleted-infoSummary">
                    <Skeleton height={24} width={160} style={{ marginBottom: 16 }} />
                    <div className="checkout-orderSummary">
                      <div className="order-summary-items">
                        {Array.from({ length: 2 }).map((_, index) => (
                          <div className="selected-products" key={index}>
                            <Skeleton height={80} width={80} borderRadius="8px" />
                            <div className="selected-products-info web-fill-width">
                              <Skeleton height={18} width="100%" />
                              <Skeleton height={14} width="50%" style={{ marginTop: 8 }} />
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="order-summary-total">
                        <div className="orderSummary-list">
                          {Array.from({ length: 3 }).map((_, index) => (
                            <div className="order-summary-list" key={index}>
                              <Skeleton height={16} width={80} />
                              <Skeleton height={16} width={60} />
                            </div>
                          ))}
                        </div>
                        <div className="orderSummary-total">
                          <div className="order-summary-list">
                            <Skeleton height={20} width={50} />
                            <Skeleton height={20} width={70} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
